import React, { FC } from 'react'

import { IconNfcProps } from './IconNfc.types'
import * as Styled from './styles/IconNfc.style'

import { nonThemeableRules } from '../../ruleSet'

const IconNfc: FC<IconNfcProps> = ({
  size = nonThemeableRules.defaultSize as number as IconNfcProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconNfcProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M136 0h-24.19l.1.09A54.58 54.58 0 0 1 128 38.94v116.67l-66-65V71l50 49.25V38.94A39 39 0 0 0 73 0H24A24.07 24.07 0 0 0 0 24v112a24.07 24.07 0 0 0 24 24h24.19l-.1-.09A54.58 54.58 0 0 1 32 121.06V4.39l66 65V89L48 39.75v81.31A39 39 0 0 0 87 160h49a24.07 24.07 0 0 0 24-24V24a24.07 24.07 0 0 0-24-24z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconNfc
